<template>
  <b-row>
    <b-col cols="4">
      <BfInput
        label="Nº de encargo"
        data-key="encargo_numero"
        :value="data.encargo_numero"
        :errors="errors"
        readonly
      />
    </b-col>

    <b-col cols="4">
      <BfInput
        label="Cliente"
        data-key="encargo_cliente_nombre"
        :value="data.encargo_cliente_nombre"
        :errors="errors"
        readonly
      />
    </b-col>

    <b-col cols="4">
      <BfDatePicker
        label="Abierta desde"
        data-key="fecha_hora_creacion"
        :value="data.fecha_hora_creacion"
        value-format="yyyy-MM-dd HH:mm:ss"
        @update="updateForm"
        :errors="errors"
        readonly
      />
    </b-col>

<!--segunda fila-->

    <b-col cols="4">
      <BfSelect
        label="Tasador encargado"
        data-key="tasador_asignado_id"
        :value="data.tasador_asignado_nombre"
        :edit-mode="editing"
        :errors="errors"
        :options="assessorSelectOptions"
        @update="updateForm"
      />
    </b-col>


    <b-col cols="4">
      <BfSwitch
        :value="data.externa"
        label="Externa"
        data-key="externa"
        @change="updateForm"
      />
    </b-col>


    <b-col cols="6">
      <BfInput
        label="Motivo *"
        data-key="motivo"
        :value="data.motivo"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 10 }"
      />
    </b-col>

     <b-col cols="12">
      <BfInput
        label="Descripción"
        data-key="comentarios"
        :value="data.comentarios"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 10 }"
      />
    </b-col>

    <b-col cols="6" class="pt-2">
      <label
        for="revision_form_resolved_toggle"
        class="small d-block mb-1 text-secondary"
        style="cursor: pointer;"
      >
        Resuelta en: <template v-if="data.estaResuelta">
          <strong>{{formatedResolveDate}}</strong>
        </template>
        <template v-else>–</template>
      </label>
      <BfSwitch
        :value="data.estaResuelta"
        data-key="estaResuelta"
        :left-border="false"
        :display-label="false"
        @update="updateForm"
      />
    </b-col>

     <b-col cols="6" class="pt-3">
      <BfDatePicker
        label="Fecha de cierre"
        data-key="fecha_hora_cerrada"
        :value="data.fecha_hora_cerrada"
        value-format="yyyy-MM-dd HH:mm:ss"
        @update="updateForm"
        :errors="errors"
      />
    </b-col>


    <!--cerrada con switch y automatico (necesita cambios en back)-->
   <!--  <b-col cols="6" class="pt-3">
      <label
        for="revision_form_closed_toggle"
        class="small d-block mb-1 text-secondary"
        style="cursor: pointer;"
      >
        Cerrada en: <template v-if="data.estaCerrada">
          <strong>{{formattedCloseDate}}</strong>
        </template>
        <template v-else>–</template>
      </label>
      <BfSwitch
        :value="data.estaCerrada"
        data-key="estaCerrada"
        :left-border="false"
        :display-label="false"
        @update="updateForm"
      />
    </b-col> -->


  </b-row>
</template>

<script>
import { moment } from '@/utils';

export default {
  name: 'RetainedForm',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },

    assessorSelectOptions: {
      type: Array,
    },

    typeSelectOptions: {
      type: Array,
    },
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },

    updateFormCheckbox(value, key) {
      this.updateForm({
        value,
        key,
      });
    },
  },

  computed: {
    formatedResolveDate() {
      if (this.data.fecha_hora_resolucion) {
        return moment(this.data.fecha_hora_resolucion).format('DD-MM-YYYY HH:mm:ss');
      }

      return '';
    },

    formattedCloseDate() {
      if (this.data.fecha_hora_cerrada) {
        return moment(this.data.fecha_hora_cerrada).format('DD-MM-YYYY HH:mm:ss');
      }

      return '';
    },
  },
};
</script>
